import React from "react";
import { isNonRevenueOrCapitalProject } from "./commercialSubphases";
import {
  fileDisplayLabelFromStoredValue,
  fileUrlFromStoredValue,
  openProjectFileUrl,
} from "./CommercialFieldFileDisplay";

function WoApprovalDocRow({ label, value, fieldKey, accept = ".pdf" }) {
  const fileUrl = fileUrlFromStoredValue(value);
  const displayName = fileUrl ? fileDisplayLabelFromStoredValue(value, { fieldKey, accept }) : null;

  return (
    <div className="landing-wo-approval-row">
      <span className="landing-wo-approval-label">{label}</span>
      {fileUrl ? (
        <button
          type="button"
          className="landing-wo-approval-link"
          onClick={() => openProjectFileUrl(fileUrl)}
        >
          {displayName}
        </button>
      ) : (
        <span className="landing-wo-approval-missing">Not uploaded</span>
      )}
    </div>
  );
}

export function LandingWoApprovalKpiCard({ summary }) {
  const s = summary && typeof summary === "object" ? summary : {};
  const nonRevenue = isNonRevenueOrCapitalProject(s);
  const hasSigned = Boolean(fileUrlFromStoredValue(s.signed_work_order));
  const hasExecuted = Boolean(fileUrlFromStoredValue(s.executed_service_order));
  const availableCount = nonRevenue
    ? hasSigned ? 1 : 0
    : (hasSigned ? 1 : 0) + (hasExecuted ? 1 : 0);

  return (
    <div className="project-kpi-card project-kpi-card--wo-approval">
      <div className="project-kpi-card-head">
        <span className="project-kpi-card-icon project-kpi-card-icon--amber">
          <svg
            className="project-landing-icon"
            aria-hidden
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M14 2v6h6M8 12h8v2H8v-2zm0 4h8v2H8v-2z" />
          </svg>
        </span>
        <h3 className="project-kpi-card-title">WO Approval</h3>
      </div>
      <span className="project-kpi-big">{availableCount}</span>
      <span className="project-kpi-sub">Available</span>
      <div className="landing-wo-approval-list">
        <WoApprovalDocRow
          label="Signed work order"
          value={s.signed_work_order}
          fieldKey="signed_work_order"
        />
        {!nonRevenue ? (
          <WoApprovalDocRow
            label="Executed service order"
            value={s.executed_service_order}
            fieldKey="executed_service_order"
          />
        ) : null}
      </div>
    </div>
  );
}
